export {};

import { initSettings } from "./settings/controller";

initSettings();
